import { QueryClientProvider } from '@tanstack/react-query'

import { ErrorBoundary, getQueryClient } from '../../../Infrastructure'
import { CheckoutProvider } from '../../Checkout'
import { UiProvider } from '../../Theme'
import { WishlistProvider } from '../../Wishlist'
import { LABELS } from '../lib'
import { HomepageProvider } from '../state'
import { HomepageSections } from './HomepageSections'

/**
 * HomepageApp - Entry point for Homepage React application
 *
 * Provider hierarchy:
 * - ErrorBoundary: Catches errors and shows fallback UI
 * - QueryClientProvider: TanStack Query for data fetching (singleton from Infrastructure)
 * - CheckoutProvider: Cart operations (add to cart, etc.)
 * - WishlistProvider: Wishlist operations (add to wishlist, etc.)
 * - UiProvider: CVA styling variants for UI components
 * - HomepageProvider: Homepage-specific state (banners, sliders, promos)
 */
export function HomepageApp() {
  return (
    <ErrorBoundary errorMessage={LABELS.HOMEPAGE_ERROR_FALLBACK}>
      <QueryClientProvider client={getQueryClient()}>
        <CheckoutProvider>
          <WishlistProvider>
            <UiProvider>
              <HomepageProvider>
                <div className="homepage-app mt-8">
                  <HomepageSections />
                </div>
              </HomepageProvider>
            </UiProvider>
          </WishlistProvider>
        </CheckoutProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
